import AMPLITUDE_EVENT_PROPERTIES from '../../consts/amplitude/amplitudeEventProperties';
import AMPLITUDE_EVENT_TYPES from '../../consts/amplitude/amplitudeEventTypes';
import {selectIsHolderConnected} from '../../state/selectors/iotDevice';
import {getState} from '../../state/store';
import amplitude from './amplitude';

const getIsHolderConnected = () => selectIsHolderConnected(getState());

const trackCheckCompatibilityScreen = () => {
    amplitude.trackProductEvent({
        isHolder: getIsHolderConnected(),
        eventType: AMPLITUDE_EVENT_TYPES.KODAK_CHECK_COMPATIBILITY_SCREEN,
    });
};

const trackLeviaLearnMoreScreen = () => {
    amplitude.trackProductEvent({
        isHolder: getIsHolderConnected(),
        eventType: AMPLITUDE_EVENT_TYPES.KODAK_LEARN_MORE_SCREEN,
    });
};

const trackUpdateFirmwareScreen = () => {
    amplitude.trackProductEvent({
        isHolder: getIsHolderConnected(),
        eventType: AMPLITUDE_EVENT_TYPES.KODAK_UPDATE_FIRMWARE_SCREEN,
    });
};

const trackLearnMoreClick = (source) => {
    amplitude.trackProductEvent({
        isHolder: getIsHolderConnected(),
        eventType: AMPLITUDE_EVENT_TYPES.KODAK_LEAR_MORE_CLICKED,
        properties: {
            [AMPLITUDE_EVENT_PROPERTIES.SOURCE]: source,
        },
    });
};

export default {
    trackLeviaLearnMoreScreen,
    trackCheckCompatibilityScreen,
    trackUpdateFirmwareScreen,
    trackLearnMoreClick,
};
